import { render, staticRenderFns } from "./StatViewItmes.vue?vue&type=template&id=2ad73d17&scoped=true"
import script from "./StatViewItmes.vue?vue&type=script&lang=js"
export * from "./StatViewItmes.vue?vue&type=script&lang=js"
import style0 from "./StatViewItmes.vue?vue&type=style&index=0&id=2ad73d17&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad73d17",
  null
  
)

export default component.exports